import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import DashboardPage from ".";

const RouterDashboard = () => {
  const { path } = useRouteMatch();
  // console.log('routerDashboard');
  // console.log(path);
  return (
    <Switch>

      <Route exact path={`${path}`}>
        <DashboardPage />
      </Route>

    </Switch>
  );
};

export default RouterDashboard;
